import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PaymentService } from 'src/app/services/payment.service';
import { CyberPaySetTransactionResponse, CyberPayLogModel } from 'src/app/model/CyberPay';
import { environment } from 'src/environments/environment';
import { resetCompiledComponents } from '@angular/core/src/render3/jit/module';

@Component({
  selector: 'app-end-cyberpay',
  templateUrl: './end-cyberpay.component.html',
  styleUrls: ['./end-cyberpay.component.css']
})
export class EndCyberpayComponent implements OnInit {

  transactionReference: string;
  Transtatus: string;
  TranMessage: string;
  status: boolean = false;
  tranFailed : boolean = false;
  tranSuccess : boolean = false;
  tranProcessing : boolean = false;
  reference: string;
  cyberpayRes: CyberPaySetTransactionResponse;
  DateCreated: string;
  Amount: string;
  PaymentStatus: string;


  constructor(private route: ActivatedRoute, private paymentService: PaymentService) {

  }

  async ngOnInit() {

    const firstParam: string = this.route.snapshot.queryParamMap.get('ref');

    if(!firstParam){
      this.tranFailed = true;
      return;
    }
    
    this.transactionReference = firstParam;
    
    try{
      
      await this.VerifyTransaction(this.transactionReference);

    }
    catch(e){

      this.tranProcessing = false;
      this.tranFailed = true;
    }


  }


  async VerifyTransaction(reference) {
    this.tranProcessing = true;
    
    let cyberpayResult = await this.paymentService.cyberPayGetTransaction(reference).toPromise();

    this.PaymentStatus = cyberpayResult.succeeded ? "SUCCESSFUL" : "FAILED";
    this.Transtatus = this.PaymentStatus;
    this.cyberpayRes = cyberpayResult;
    

    let cyberPayRequestLogRes = await this.paymentService.LteHttpGetCyberpayRequestLog(reference).toPromise();
    let response: CyberPayLogModel = cyberPayRequestLogRes.Result;
    this.DateCreated = response.DateCreated;
    this.Amount = response.ActualPayment ? response.ActualPayment.toString() : response.amount.toString() ;
    
    if (response.IsSuccessful) {
      this.tranProcessing = false;
      this.tranSuccess = true;
      return;
    }

    response.Transaction_status = this.PaymentStatus;

    if(!this.cyberpayRes.succeeded){
      

      this.tranProcessing = false;
      this.tranFailed = true;
      await this.paymentService.LteHttpUpdateLogCyberPayRequest(response).toPromise();
      return;

    }
    
    var creditRes = await  this.paymentService.LteCreditCustomer(environment.OperatorID, response.CustomerID, response.i_account, response.i_product, true, this.cyberpayRes).toPromise();
    

    if(creditRes.Status){

      response.IsSuccessful = true;
    
    }

    await this.paymentService.LteHttpUpdateLogCyberPayRequest(response).toPromise();
    
    this.tranProcessing = false;
    this.tranSuccess = true;



  }

}


























































































































